import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

function ScrollManager() {
  const location = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname, lenis]);
  return null;
}

export default function Layout({ children }) {
  const nomotion = typeof window !== "undefined" && window.location.search.includes("nomotion");
  if (nomotion) {
    return (
      <>
        <ScrollManager />
        <Header />
        <main className="min-h-screen bg-aria-ivory">{children}</main>
        <Footer />
      </>
    );
  }
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, wheelMultiplier: 0.9 }}>
      <ScrollManager />
      <Header />
      <main className="min-h-screen bg-aria-ivory">{children}</main>
      <Footer />
    </ReactLenis>
  );
}
